import { useState } from 'react';
import { api, ApiError } from '../lib/api.js';

/** AI insights (Gemini narrates computed metrics, §10). Lazy on demand. */
export function InsightsPanel({ from, to, sedes }: { from: string; to: string; sedes?: string }) {
  const [text, setText] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function generate() {
    setBusy(true);
    setError(null);
    try {
      const r = await api.insights({ from, to, sedes });
      setText(r.narrative);
    } catch (e) {
      setError(
        e instanceof ApiError && e.status === 503
          ? 'Insights no disponibles (falta configurar GEMINI_API_KEY).'
          : e instanceof Error
            ? e.message
            : 'Error generando insights.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="rounded-xl border border-slate-700 bg-slate-800/60 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-sm font-medium text-slate-200">Insights con IA</h2>
        <button
          onClick={generate}
          disabled={busy}
          className="rounded-md bg-blue-600 px-3 py-1 text-sm text-white hover:bg-blue-500 disabled:opacity-50"
        >
          {busy ? 'Generando…' : 'Generar'}
        </button>
      </div>
      {error && <p className="text-sm text-amber-400">{error}</p>}
      {text && <div className="whitespace-pre-wrap text-sm text-slate-300">{text}</div>}
      {!text && !error && (
        <p className="text-sm text-slate-500">Genera una narrativa de tendencias y anomalías.</p>
      )}
    </div>
  );
}
